import { render } from "./LocatieList.vue?vue&type=template&id=3babe165"
import script from "./LocatieList.vue?vue&type=script&lang=js"
export * from "./LocatieList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__